import React from "react"

// components
import {TextInput, Dropdown} from "./index"

// styling
import "./Form.scss"

// the component
function Form({fields, entity, onUpdate, hideFieldValidation}) {
  const onFieldChange = (e) => {
    entity[e.field] = e.value
    onUpdate({entity})
  }

  // render
  let items = fields.map(f => {
    let item = null;
    switch(f.kind) {
      case "dropdown":
        item = <Dropdown 
          key={f.field}
          label={f.label} 
          options={f.options} 
          field={f.field}
          onChange={onFieldChange} 
          help={f.help}
          allowCustom={f.allowCustom}
          customPlaceholder={f.customPlaceholder}
          value={entity[f.field]}
        />
        break;
      default:
        item = <TextInput 
          autocomplete={f.autocomplete}
          key={f.field}
          field={f.field}
          value={entity[f.field]}
          label={f.label}
          help={f.help}
          multiline={f.multiline}
          maxLength={f.maxLength}
          mandatory={f.mandatory}
          validate={f.validate}
          onChange={onFieldChange}
          hideValidation={hideFieldValidation}
        />
        break;
    }
    return item;
  })

  return (
    <div className="c-form">
      {items}
    </div>
  )
}

export default Form

